import { combineLatest, firstValueFrom } from "rxjs";
import type { AuthService } from "./shared/services/auth.service";

// Let the letters finish dropping in before fading out, so fast loads don't flash
const MIN_VISIBLE_MS = 1000;
// Never trap someone behind the loader if auth hangs
const MAX_VISIBLE_MS = 15000;

const shownAt = performance.now();

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Fades out the loading takeover in index.html once auth has settled: the
 * user (or lack of one) has resolved, including any email link or redirect
 * sign-in, and their role claims are known.
 */
export async function hideLoaderWhenAuthSettles(
  authService: Promise<AuthService>
): Promise<void> {
  const settled = authService.then((auth) =>
    firstValueFrom(combineLatest([auth.user, auth.claims]))
  );
  await Promise.race([settled, delay(MAX_VISIBLE_MS)]).catch(console.error);
  await delay(MIN_VISIBLE_MS - (performance.now() - shownAt));

  const loader = document.getElementById("loader");
  if (!loader) return;
  loader.addEventListener("transitionend", () => loader.remove(), { once: true });
  loader.classList.add("loader-done");
}
